import { setDocumentation } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [forAction(setDocumentation, identityPayload)],
  initialState,
);
